<script setup lang="tsx">
import { ref } from "vue";
import {
  createCommonPhoneValidator,
  createCommonLengthValidator
} from "@zyzgroup/core-common";
import { context } from "../../context/context";
import { loading, toast } from "../../globalTeleport";
import { useRouter } from "../../hooks/useVueRouter";
import Page from "../base/Page.vue";
import Input from "../form/Input.vue";
import Button from "../form/Button.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Page, Input, Button },
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const router = useRouter();

const disabledCaptcha = ref(true);
const disabledLogin = ref(true);

const commonPhoneValidator = createCommonPhoneValidator({
  emptyError: "请输入手机号",
  error: "请输入正确的手机号"
});
const commonLengthValidator = createCommonLengthValidator(4, {
  emptyError: "请输入验证码",
  error: "验证码必须为4位数"
});

let phone = "";
function inputPhone(v) {
  phone = v;
  checkBtnStatus();
}

let captcha = "";
function inputCaptcha(v) {
  captcha = v;
  checkBtnStatus();
}

function checkBtnStatus() {
  disabledCaptcha.value = !!captchaInterval || !phone;
  disabledLogin.value = !phone || !captcha;
}

const captchaText = ref("获取验证码");
let captchaInterval;

async function clickCaptcha() {
  if (captchaInterval) {
    return;
  }
  disabledCaptcha.value = true;
  context.ds.immediately(loading);
  context.axios
    .post("/api/v2/auth/genValidSN", { mobileno: phone })
    .then((result) => {
      context.ds.closeLast();
      let count = 60;
      captchaText.value = `${count}秒后可重发`;
      captchaInterval = setInterval(() => {
        count--;
        captchaText.value = `${count}秒后可重发`;
        if (count == 0) {
          clearInterval(captchaInterval);
          captchaInterval = undefined;
          captchaText.value = `获取验证码`;
          checkBtnStatus();
        }
      }, 1000);
    })
    .catch((result) => {
      context.ds.immediately(toast, {
        status: "error",
        content: result.data.error || JSON.stringify(result.data),
        onClose: () => {
          checkBtnStatus();
        }
      });
    });
}

function clickLogin() {
  context.ds.immediately(loading);
  context.axios
    .post("/api/v2/auth/quickLogin", {
      mobileno: phone,
      validsn: captcha,
      ufrom: "h5"
    })
    .then((result) => {
      const token = result.data.r.token;
      context.static.token.set(token);
      context.store.dispatch({
        type: "SET_USER",
        payload: result.data.r || {}
      });
      context.ds.immediately(toast, {
        status: "success",
        content: "登录成功",
        onClose: () => {
          router.back();
        }
      });
    })
    .catch((result) => {
      context.ds.immediately(toast, {
        status: "error",
        content: result.data.error || JSON.stringify(result.data),
        onClose: () => {
          checkBtnStatus();
        }
      });
    });
}
</script>

<template>
  <Page class="login-in-phone">
    <div class="title">手机验证码登录</div>
    <div class="phone">
      <Input
        placeholderType="underline"
        placeholder="请输入手机号"
        :showError="true"
        :validator="commonPhoneValidator"
        @input="inputPhone"
      ></Input>
    </div>
    <div class="captcha">
      <Input
        placeholderType="underline"
        placeholder="请输入验证码"
        :showError="true"
        :validator="commonLengthValidator"
        @input="inputCaptcha"
      >
        <Button
          mode="transparent"
          :disabled="disabledCaptcha"
          @throttled-click="clickCaptcha"
        >
          {{ captchaText }}
        </Button>
      </Input>
    </div>
    <div class="btn">
      <Button
        mode="primary"
        :capsule="true"
        width="100%"
        :disabled="disabledLogin"
        @throttled-click="clickLogin"
      >
        登录
      </Button>
    </div>
  </Page>
</template>

<style scoped>
.login-in-phone {
  padding: 0.76rem 0.6rem 0.6rem;
}
.login-in-phone .title {
  font-size: 20px;
  font-weight: bold;
}
.login-in-phone .phone {
  margin-top: 0.3rem;
}
.login-in-phone .captcha {
  margin-top: 0.3rem;
}
.login-in-phone .btn {
  margin-top: 0.6rem;
}
</style>
